import useSEO from "@/hooks/useSEO";
import LogoIntro from "@/components/LogoIntro";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import StatsBar from "@/components/StatsBar";
import About from "@/components/About";
import MenuHighlights from "@/components/MenuHighlights";
import Terrasse from "@/components/Terrasse";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import Bewerben from "@/components/Bewerben";
import Hours from "@/components/Hours";
import Footer from "@/components/Footer";

export default function Home() {
  useSEO({
    title: "Niko's Grill · Griechisches Restaurant in Bochum-Höntrop",
    description:
      "Authentisches griechisches Restaurant in Bochum-Höntrop. Gyros, Souvlaki & Metaxa-Sauce vom Holzkohlegrill. 4,7★ bei 943 Google-Bewertungen. Reservierung: +49 2327 995454.",
    path: "/",
  });

  return (
    <main className="bg-[var(--niko-cream)]" data-testid="home-page">
      <LogoIntro />
      <Navbar />
      <Hero />
      <StatsBar />
      <About />
      <MenuHighlights />
      <Terrasse />
      <Gallery />
      <Reviews />
      <Bewerben />
      <Hours />
      <Footer />
    </main>
  );
}
